"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Merchandising = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _FormattedMessage = require("./FormattedMessage");
var _MerchandisingBlock = require("./MerchandisingBlock");
var _jsxRuntime = require("react/jsx-runtime");
const Wrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        maxWidth: 984,
        padding: theme.spacing(2, 3, 3, 3),
        backgroundColor: theme.palette.grey[100],
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(0)
        }
    };
});
const WrapperHeading = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        marginBottom: theme.spacing(2),
        fontSize: '2rem',
        fontWeight: 'bold',
        color: theme.palette.text.primary
    };
});
const Merchandising = (param)=>{
    let { messages, ordersAmount, pendingOrders, ordersPageLink } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Wrapper, {
        "data-testid": getTestId('wrapper'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(WrapperHeading, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                    id: "dontMissOut"
                })
            }),
            messages.map((messageItem, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_MerchandisingBlock.MerchandisingBlock, {
                    "data-testid": getTestId("block-".concat(messageItem.hintCategory, "-").concat(index)),
                    hintCategory: messageItem.hintCategory,
                    title: messageItem.title,
                    text: messageItem.text,
                    toolTip: messageItem.toolTip,
                    progress: messageItem.progress,
                    ordersAmount: ordersAmount !== null && ordersAmount !== void 0 ? ordersAmount : 0,
                    pendingOrders: pendingOrders !== null && pendingOrders !== void 0 ? pendingOrders : [],
                    ordersPageLink: ordersPageLink
                }, index))
        ]
    });
};
exports.Merchandising = Merchandising;
